<script>
    import BaseDialog from './BaseDialog.svelte';
    import { event } from '../../../../guides/guide';

    let {
        dialogRef = $bindable(),
        doneComment = $bindable(),
        brokenComment = $bindable(),
        auditSelection = $bindable(),
        onDone,
        onSkip,
        onBroken,
        cbtn = "",
        dbtn = ""
    } = $props();
</script>

<BaseDialog bind:dialogRef={dialogRef} size="sm:max-w-3xl" title="Close Transcript, Move to Next File">
    {#snippet children({ dialog })}
        <div class="overflow-auto p-6">
            <div class="space-y-4">
                <div>
                    <button class="{cbtn} w-full py-3 text-lg font-medium" onclick={onDone} use:event.dispatch={'drew_done'}>✓ Done</button>
                </div>

                <textarea
                    class="focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-lg border-gray-300 shadow-sm px-4 py-3"
                    bind:value={doneComment}
                    placeholder="Add optional comment..."
                    rows="3"
                ></textarea>

                <div class="border-t border-gray-200 pt-4">
                    <h4 class="font-medium text-gray-900 mb-3">Was there a problem with this file?</h4>
                    <div class="space-y-3 pl-2">
                        <label class="flex items-center space-x-3 cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition">
                            <input
                                class="focus:ring-2 focus:ring-indigo-500 h-5 w-5 text-indigo-600 border-gray-300 rounded"
                                type="radio"
                                bind:group={auditSelection}
                                value="skip"
                            />
                            <span class="text-gray-700 font-medium">Skip this file</span>
                        </label>

                        <label class="flex items-center space-x-3 cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition">
                            <input
                                class="focus:ring-2 focus:ring-indigo-500 h-5 w-5 text-indigo-600 border-gray-300 rounded"
                                type="radio"
                                bind:group={auditSelection}
                                value="broken"
                            />
                            <span class="text-gray-700 font-medium">Mark as broken</span>
                        </label>
                    </div>
                </div>

                {#if auditSelection === 'broken'}
                    <textarea
                        class="focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-lg border-gray-300 shadow-sm px-4 py-3"
                        bind:value={brokenComment}
                        placeholder="Describe the issue..."
                        rows="3"
                    ></textarea>
                {/if}

                {#if auditSelection === 'skip'}
                    <button class="{dbtn} w-full py-3 text-lg font-medium" data-close-dialog onclick={onSkip}>Confirm Skip</button>
                {/if}
                {#if auditSelection === 'broken'}
                    <button class="{dbtn} w-full py-3 text-lg font-medium" data-close-dialog onclick={onBroken}>Confirm Broken</button>
                {/if}
            </div>
        </div>
    {/snippet}
</BaseDialog>
